import React, { useEffect, useReducer } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { formDataValidate } from '../../../../../../utils/formUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';
import { fetchIntegrationStatus } from '../../../../configurationSlice';

const CentralReservationSystem = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedHotel) dispatch(fetchIntegrationStatus(selectedHotel));
  }, [selectedHotel]);

  const [formData, setFormData] = useReducer((s, n) => ({ ...s, ...n }), {
    integrationSource: { value: '', fieldName: 'Integration Source', errors: {}, validations: [] },
    integrationSourceSelected: { value: '', fieldName: 'Vendor', errors: {}, validations: [] },
  });

  const validate = () => {
    const updated = {};
    const ok = formDataValidate(formData, updated);
    setFormData(updated);
    return ok;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      if (!validate()) return;
      notificationManager('success', 'CRS settings saved');
    } catch (err) {
      if (ENVIRONMENT === 'dev') console.log(err?.message);
      notificationManager('danger', 'Unable to save CRS settings');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <form onSubmit={handleSubmit} className='crs' noValidate>
      <div className='col-12 hotel-service-tab-section'>
        <div className='col col-xl-6'>
          <Tabs
            value={0}
            variant='fullWidth'
            indicatorColor='primary'
            onChange={() => {}}
            textColor='primary'
            className='property-tabs'
          >
            <Tab label='Integration Settings' />
          </Tabs>
        </div>
      </div>

      <div className='mx-4'>
        <IntegrationSource
          formData={formData}
          setFormData={setFormData}
          section='CRS'
          headTitle='Integration Source'
          showLoader={showLoader}
        />
      </div>
    </form>
  );
};

export default CentralReservationSystem;
